'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

exports.createMessageGroups = createMessageGroups;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates a message group.
 */
var createGroup = function createGroup(mine) {
  return {
    mine: mine,
    messages: []
  };
};

/**
 * Creates messages groups from a flat list of messages.
 *
 * @param  {Message[]} messages
 * List of messages.
 *
 * @param  {User} me
 * The user acting as the "me" of the conversation.
 *
 * @return {object[]}
 * Message groups.
 */
function createMessageGroups(messages, me) {
  var groups = [];

  // Skip work when there's no work to be done.
  if (!messages || messages.length === 0) {
    return groups;
  }

  var currentGroup = void 0,
      previousMessage = void 0;

  // Used to keep track of the message that a user had last seen.
  var seenByMap = new _map2.default();
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    var _loop = function _loop() {
      var message = _step.value;

      var mine = message.sender === me;
      if (!currentGroup) {
        currentGroup = createGroup(mine);
        groups.push(currentGroup);
      }

      // Based on this message's sender and the previous one,
      // determines if we need to end the current group and start
      // a new one.
      if (previousMessage && previousMessage.message.sender !== message.sender) {
        currentGroup.lastMessage = previousMessage;
        currentGroup = createGroup(mine);
        groups.push(currentGroup);
      }

      // We need to attach extra shit on the message, which we
      // don't want on the original model.
      var newMessage = {
        message: message,
        // "seen by" is kinda misleading. This array will contain avatar URL's that
        // should be displayed next to the message - that means the message
        // above it has been seen, but it won't have the avatars set,
        // because only the message that was last seen by a user will appear.
        seenBy: []
      };

      currentGroup.messages.push(newMessage);
      previousMessage = newMessage;

      message.recipientStatus.filter(function (rs) {
        return rs.status === 'read' && !!rs.recipient;
      }).forEach(function (rs) {
        return seenByMap.set(rs.recipient, newMessage);
      });
    };

    for (var _iterator = (0, _getIterator3.default)(messages), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      _loop();
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  currentGroup.lastMessage = previousMessage;

  // We now have the messages that recipients have last seen.
  // We attach that to each corresponding message.
  seenByMap.forEach(function (message, recipient) {
    return message.seenBy.push(recipient.avatar || recipient.picture || recipient.avatarFallback);
  });

  return groups;
}
//# sourceMappingURL=conversationUtil.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/utils/conversationUtil.js
// module id = 635
// module chunks = 0